import { parseDateWithHours } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

export type ConnectorConfig = {
  id: number;
  protocol?: string | null;
  connector?: string | null;
  path?: string | null;
  method?: string | null;
  unzip_strategy?: string | null;
  file_pattern?: string | null;
  email_source_type?: string | null;
  email_subject_user?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
};

export const connector_configs_columns: ColumnDef<ConnectorConfig>[] = [
  { accessorKey: "id", header: "ID" },
  { accessorKey: "protocol", header: "Protocol" },
  { accessorKey: "connector", header: "Connector" },
  { accessorKey: "path", header: "Path" },
  { accessorKey: "method", header: "Method" },
  { accessorKey: "unzip_strategy", header: "Unzip Strategy" },
  { accessorKey: "file_pattern", header: "File Pattern" },
  { accessorKey: "email_source_type", header: "Email Source Type" },
  { accessorKey: "email_subject_user", header: "Email Subject User" },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => {
      const val = row.getValue("created_at");
      return val ? parseDateWithHours(val as string) : null;
    },
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => {
      const val = row.getValue("updated_at");
      return val ? parseDateWithHours(val as string) : null;
    },
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end gap-2">
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
